/** @format */
import { css } from 'styled-components';

import { CriteriaListProps } from './index';

/**
 * Base styles for the CriteriaList component
 */
const baseStyles = () => css`
    padding-left: 0;

    h3 {
        display: inline;
        margin-right: 1.2rem;
        color: var(--colors-text-secondary);
    }

    .criteria-box {
        margin: 0 0.8rem 0.8rem 0;
    }
`;

/**
 * The CriteriaList component styles
 *
 * @param {CriteriaListProps} props The criteria-list properties object
 */
export const styles = (props: CriteriaListProps) => css`
    ${baseStyles()}
`;
